import type { InvestorProfileData } from '../../api/investor-profile.api';

/** What the platform already knows about the logged-in person (FR-187, A-205). */
export interface InvestorPrefill {
  /** The person's own name, from their account profile. */
  contactName?: string;
  /** The person's login email. */
  email?: string;
}

/**
 * The setup form's data for a profile that does not exist yet: Contact Name holds the
 * person's own name and Email their login email. A value already saved always wins, and
 * an existing profile is returned untouched, so editing a section never refills a field
 * the user cleared. Pure.
 */
export function withNewProfilePrefill(
  data: InvestorProfileData,
  prefill: InvestorPrefill,
): InvestorProfileData {
  if (data.id) return data;
  return {
    ...data,
    contactName: data.contactName || prefill.contactName,
    email: data.email || prefill.email,
  };
}
